import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

// WhatsApp configuration - easily replaceable
const WHATSAPP_CONFIG = {
  number: '+905524278605', // Replace with actual number
  message: 'Merhaba, GEVEZ SOFTWARE hizmetleri hakkında bilgi almak istiyorum.',
};

export const WhatsAppFloat = () => {
  const openWhatsApp = () => {
    const url = `https://wa.me/${WHATSAPP_CONFIG.number.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(WHATSAPP_CONFIG.message)}`;
    window.open(url, '_blank');
  };

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={openWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center
                 shadow-[0_0_20px_rgba(37,211,102,0.5)] hover:shadow-[0_0_30px_rgba(37,211,102,0.7)] transition-shadow"
      aria-label="WhatsApp ile iletişim"
      data-testid="whatsapp-float"
    >
      {/* Pulse animation */}
      <span className="absolute w-full h-full rounded-full bg-[#25D366] animate-ping opacity-20" />
      
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </motion.button>
  );
};

export default WhatsAppFloat;
